module.exports = __webpack_public_path__ + "static/img/2.bdbbb60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/2.png
// module id = oKOr
// module chunks = 0